<template>
  <div class="text-style-sm flex items-center gap-1">
    {{
      $t("components.task_details.created_by", {
        date: formatDate(task.created_at),
        name: name,
      })
    }}
    <Assignees v-if="creator" :assignees="[creator]" size="md" />
  </div>
</template>

<script setup>
import { computed } from "vue";
import { Assignees } from "@/SharedComponents/Assignees";
import { useDate } from "@/Composables/useDate";
import { useI18n } from "vue-i18n";

const { formatDate } = useDate();
const { t } = useI18n();

const props = defineProps({
  task: {
    type: Object,
    required: true,
  },
});

const creator = computed(() => props.task?.created_by);

const name = computed(() => {
  if (creator.value) return "";

  if (props.task.recurrence || props.task.reminder) {
    return "Fixform";
  }

  const anonymousReporter = props.task?.problem?.messenger;
  return `${t("components.visitor")} (${
    anonymousReporter?.name ||
    anonymousReporter?.email ||
    anonymousReporter?.mobile ||
    t("components.anonymous")
  })`;
});
</script>
